import React, { useState, useEffect } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { useTranslation } from "react-i18next";
import "./contact.css";

function ContactEmail() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [sending, setSending] = useState(false);

  useEffect(() => {
    emailjs.init("IyzrrMLeesthFmSC7");
  }, []);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = t("form_error_name");
    if (!formData.email.trim()) newErrors.email = t("form_error_email_required");
    else if (!validateEmail(formData.email)) newErrors.email = t("form_error_email_invalid");
    if (!formData.message.trim()) newErrors.message = t("form_error_message");

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    setSending(true);

    emailjs
      .send("service_aiqcgge", "template_ek5hkpa", {
        from_name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      })
      .then(
        () => {
          alert(t("form_success", "Message sent successfully!"));
          setFormData({ name: "", email: "", phone: "", message: "" });
          setSending(false);
        },
        () => {
          alert(t("form_error_send", "Failed to send message. Try again later."));
          setSending(false);
        }
      );
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h2>{t("contact_title")}</h2>
        <p>{t("contact_subtitle")}</p>
      </div>

      <div className="contact-wrapper">
        <div className="contact-left">
          <div className="contact-form-card">
            <h3 className="form-title">{t("form_title")}</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>{t("form_name_label")}</label>
                <input
                  type="text"
                  name="name"
                  placeholder={t("form_name_placeholder")}
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="error">{errors.name}</p>}
              </div>

              <div className="form-group">
                <label>{t("form_email_label")}</label>
                <input
                  type="email"
                  name="email"
                  placeholder={t("form_email_placeholder")}
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="error">{errors.email}</p>}
              </div>

              <div className="form-group">
                <label>{t("form_phone_label")}</label>
                <input
                  type="text"
                  name="phone"
                  placeholder={t("form_phone_placeholder")}
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>{t("form_message_label")}</label>
                <textarea
                  name="message"
                  placeholder={t("form_message_placeholder")}
                  value={formData.message}
                  onChange={handleChange}
                />
                {errors.message && <p className="error">{errors.message}</p>}
              </div>

              <button className="send-btn" type="submit" disabled={sending}>
                {sending ? t("form_sending") : t("form_send_btn")} <FaPaperPlane />
              </button>
            </form>
          </div>
        </div>

        <div className="contact-right">
          <div className="info-card">
            <h3>{t("info_title")}</h3>
            <div className="info-item">
              <div className="info-icon"><FaPhoneAlt /></div>
              <div>
                <h4>{t("info_phone_title")}</h4>
                <p>{t("info_phone_text")}</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon"><FaEnvelope /></div>
              <div>
                <h4>{t("info_email_title")}</h4>
                <p>{t("info_email_text")}</p>
              </div>
            </div>
            <div className="info-item">
              <div className="info-icon"><FaMapMarkerAlt /></div>
              <div>
                <h4>{t("info_location_title")}</h4>
                <p>{t("info_location_text")}</p>
              </div>
            </div>
          </div>

          <div className="info-card business-card">
            <h3>{t("business_hours_title")}</h3>
            <div className="hours-row">
              <span>{t("hours_mon_fri")}</span>
              <span>{t("hours_mon_fri_time")}</span>
            </div>
            <div className="hours-row">
              <span>{t("hours_sat")}</span>
              <span>{t("hours_sat_time")}</span>
            </div>
            <div className="hours-row">
              <span>{t("hours_sun")}</span>
              <span>{t("hours_sun_time")}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="map-full info-card">
        <h3>{t("map_title")}</h3>
        <div className="map-box">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d23410.668570624977!2d20.953358285684438!3d42.82356713037732!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13535b8d8eb86a37%3A0x8524b6e1715d23eb!2sVushtrri%2042000!5e0!3m2!1ssq!2s!4v1764610678380!5m2!1ssq!2s"
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
            title="MHome Map"
          ></iframe>
        </div>
      </div>
    </div>
  );
}

export default ContactEmail;
